export function fetchTypes() { return { type: 'COUPON_TYPES/FETCH' } }
export function fetch(idLeague) { return { type: 'COUPON/FETCH', idLeague } }